/* Global behaviour: cart drawer toggles, mobile filter drawer, toast. Vanilla JS, no dependencies. */
(function () {
  var body = document.body;

  window.mpToast = function (msg) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    var m = t.querySelector('[data-toast-msg]');
    if (m) m.textContent = msg;
    t.classList.add('show');
    clearTimeout(window.__mpToastTimer);
    window.__mpToastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  };

  window.mpOpenCart = function () {
    body.classList.add('cart-open');
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      var close = drawer.querySelector('[data-close-cart]');
      if (close) close.focus({ preventScroll: true });
    }
  };
  window.mpCloseCart = function () { body.classList.remove('cart-open'); };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open-cart]');
    if (open) {
      // On the cart page, follow the link instead of opening the drawer.
      if (body.classList.contains('template-cart')) return;
      e.preventDefault();
      window.mpOpenCart();
      return;
    }
    if (e.target.closest('[data-close-cart]')) { window.mpCloseCart(); return; }
    if (e.target.closest('[data-fopen]')) { body.classList.add('f-open'); return; }
    if (e.target.closest('[data-fclose]')) { body.classList.remove('f-open'); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      window.mpCloseCart();
      body.classList.remove('f-open');
    }
  });
})();
